module.exports = __webpack_public_path__ + "img/experience1.704ada5f.png";